// Contact Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    const notyf = new Notyf();
    // Map functionality
    initializeMaps();

    const form = document.querySelector('.contato-form__fields');

    form.addEventListener('submit', function (e) {
        e.preventDefault(); 
            const url = form.getAttribute('data-url');
            const formData = new FormData(form);
            grecaptcha.ready(() => {
            grecaptcha.execute(document.getElementById("recaptcha").value, {
                action: 'submit'
            }).then(token => {
                formData.append('gRecaptchaResponse', token);
            fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                     notyf.success(data.txt || 'Mensagem enviada com sucesso!');
                    form.reset();
                } else {
                     notyf.error(data.txt || 'Erro ao enviar mensagem.');
                }
            })
            .catch(() => {
                notyf.error('Erro ao enviar mensagem.');
            });
    });
    });
});

});

function initializeMaps() {
    const mapContainers = document.querySelectorAll('.contato-map');

    const latitude = parseFloat(document.getElementById('lat').value);
    const longitude = parseFloat(document.getElementById('lng').value);
    const addressLink = document.getElementById('addressLink').value;
    const address = document.getElementById('address').value;
    const iconUrl = document.getElementById('map-icon').value;

    const popupPositions = [
        0,
        window.innerWidth > 992 ? -60 : -30
    ];

    // ícone personalizado (global)
    const myIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [77, 77],
        popupAnchor: popupPositions
    });

    // rederiza um mapa em cada container
    mapContainers.forEach(container => {
        const map = L.map(container, {
            closePopupOnClick: false
        }).setView([latitude, longitude], 14);

        // Desativa zoom com scroll
        map.scrollWheelZoom.disable();

        // Adiciona camada base
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 16
        }).addTo(map);

        // Adiciona marcador
        const marker = L.marker([latitude, longitude], {
            icon: myIcon,
            draggable: false,
            title: 'RodoTécnica'
        }).addTo(map);

        // Adiciona popup
        marker.bindPopup(
            `<p>
                <a href="${addressLink}" target="_blank" aria-label="navegar para mapa">
                    ${address}
                </a>
            </p>`,
            {
                autoClose: false,
                closeButton: false,
                closeOnClick: false,
                keepInView: true
            }
        ).openPopup();

        // Impede que o popup feche ao clicar
        marker.on('click', () => marker.openPopup());
    });
}